module.exports = __webpack_public_path__ + "assets/fresco.7d1c2072.svg";